module.exports = __webpack_public_path__ + "static/media/angle-double-prev.c865af33.svg";